// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-List-Details-module__badge__JjTUr";
var _2 = "assets-js-ViewInvitation-components-Guestlist-List-Details-module__comment__KI3QN";
var _3 = "assets-js-ViewInvitation-components-Guestlist-List-Details-module__nameColumn__ESkde";
export { _1 as "badge", _2 as "comment", _3 as "nameColumn" }
